import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SidenavService } from '../../services/sidenav.service';
import { ThemeService } from '../../services/theme.service';

@Component({
    selector: 'lib-property-panel',
    standalone: true,
    imports: [CommonModule, MatExpansionModule, MatIconModule, MatButtonModule],
    template: `
    <div class="property-panel">
        <div class="panel-header" *ngIf="title">
            <div class="flex items-center gap-3">
                <mat-icon *ngIf="icon" class="panel-icon">{{ icon }}</mat-icon>
                <h3 class="panel-title">{{ title }}</h3>
            </div>
            
            <button mat-icon-button class="close-btn sm:hidden" *ngIf="(isMobile$ | async)" (click)="close()">
                <mat-icon>expand_more</mat-icon>
            </button>
        </div>
        
        <div class="panel-content">
            <ng-content></ng-content>
        </div>
    </div>
  `,
    styles: [`
    .property-panel {
        padding: 1rem 0;
        border-bottom: 1px solid rgba(var(--mat-sys-outline), 0.05);
    }

    .panel-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.75rem;
        margin-bottom: 1.25rem;
        padding: 0 0.5rem;
    }

    .close-btn {
        margin-right: -8px;
        color: var(--mat-sys-on-surface-variant);
        opacity: 0.7;
    }

    .panel-icon {
        font-size: 20px;
        width: 20px;
        height: 20px;
        color: var(--mat-sys-primary);
    }

    .panel-title {
        font-size: 0.9rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        margin: 0;
        color: var(--mat-sys-on-surface-variant);
    }

    .panel-content {
        display: flex;
        flex-direction: column;
        gap: 1.25rem;
    }
  `]
})
export class PropertyPanelComponent {
    @Input() title?: string;
    @Input() icon?: string;

    private readonly sidenavService = inject(SidenavService);
    private readonly themeService = inject(ThemeService);

    isMobile$ = this.themeService.breakpoints.isMobile$;

    close() {
        this.sidenavService.setRightOpen(false);
    }
}
